import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditBrands from '../../components/brands/FormAddEditBrands';
import { useGetBrandById } from '../../hooks/brands/useGetBrandById';
import LoadingPage from '../../components/global/LoadingPage';

const EditBrand = () => {
    const { id } = useParams();
    const { brand, isLoading } = useGetBrandById(id);
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/brands");
    };

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBrands isEdit={true} currentData={brand} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default EditBrand;
